import { type FC, lazy, Suspense, useState } from "react";
import { useAuth } from "../../contexts/AuthProvider";
import { useRecommendationsDrawerContext } from "../../contexts/RecommendationsDrawerContext";
import { isHeadNurse } from "../../utils/utilFunctions";

// Lazy: the panel reaches the staffing-changes dialog, whose import graph loops back to the router, and every tab's
// screen. Loading it on the first open keeps that graph (and its weight) out of the layout, which every page renders.
const UpdatesPanel = lazy(() => import("./UpdatesPanel").then((module) => ({ default: module.UpdatesPanel })));

/**
 * Where the admin side panel lives: mounted once by `Layout` for every admin page, so the bell and the staffing
 * drawer trigger open the same panel. Renders nothing for staff (their bell keeps its own popover) and nothing at
 * all until the panel first opens.
 */
export const UpdatesPanelMount: FC = () => {
	const { userInfo } = useAuth();
	const { isOpen } = useRecommendationsDrawerContext();
	const [hasOpened, setHasOpened] = useState(isOpen);
	if (isOpen && !hasOpened) setHasOpened(true);

	if (!isHeadNurse(userInfo.role) || !hasOpened) return null;
	return (
		<Suspense fallback={null}>
			<UpdatesPanel />
		</Suspense>
	);
};
